import { Routes } from '@angular/router';
import { AutoLoginAllRoutesGuard } from 'angular-auth-oidc-client';
import { CanLoginGuard } from '../shared/guards/can-login/can-login.guard';

export const routes: Routes = [
	{
		path: 'home',
		loadChildren: () =>
			import('./home/home.routes').then((m) => m.HOME_ROUTES),
		canLoad: [AutoLoginAllRoutesGuard],
		canActivate: [CanLoginGuard],
		data: { preload: true }
	},
	{
		path: '**',
		redirectTo: 'home'
	}
];
